(() => {
  if (customElements.get('reacher-hero-carousel-v3')) return;
  customElements.define('reacher-hero-carousel-v3', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.track = this.querySelector('[data-hero-track]');
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.listen = (target, event, fn) => target.addEventListener(event, fn, { signal });
      this.listen(this, 'click', e => {
        const button = e.target.closest('[data-hero-action]');
        if (!button) return;
        const action = button.dataset.heroAction;
        if (action === 'pause') {
          this.paused = !this.paused;
          this.schedule();
        } else {
          this.paused = true;
          this.show(action === 'select' ? Number(button.dataset.slide) : action === 'next' ? this.index + 1 : this.index - 1);
        }
        this.updatePause();
      });
      this.listen(this, 'keydown', e => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key) || /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
        e.preventDefault();
        this.paused = true;
        this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1));
        this.updatePause();
      });
      this.listen(this.track, 'pointerdown', () => {
        this.paused = true;
        this.schedule();
        this.updatePause();
      });
      this.listen(this.track, 'scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth));
          this.schedule();
        }, 120);
      });
      this.resizeObserver = new ResizeObserver(() => {
        this.track.scrollTo({ left:this.index * this.track.clientWidth, behavior:'instant' });
      });
      this.resizeObserver.observe(this.track);
      this.listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      this.listen(this, 'focusout', e => { this.focused = this.contains(e.relatedTarget); this.schedule(); });
      this.listen(document, 'visibilitychange', () => this.schedule());
      this.listen(this.motion, 'change', () => { this.updatePause(); this.schedule(); });
      this.listen(document, 'shopify:block:select', e => {
        if (!this.contains(e.target)) return;
        this.paused = true;
        this.show(1);
        const card = e.target.closest('.rh21-hero-card');
        if (card) this.cards.forEach(item => item.classList.toggle('is-current', item === card));
        this.updatePause();
      });
      this.cards = [...this.querySelectorAll('.rh21-hero-card')];
      this.cardIndex = 0;
      this.cardTimer = setInterval(() => {
        if (this.index !== 1 || this.motion.matches || document.hidden || this.focused || window.Shopify?.designMode) return;
        this.cardIndex = (this.cardIndex + 1) % Math.max(this.cards.length, 1);
        this.cards.forEach((card, i) => card.classList.toggle('is-current', i === this.cardIndex));
      }, 3000);
      this.querySelector('[data-hero-controls]').hidden = false;
      this.show(0);
      this.updatePause();
    }
    show(index) {
      this.setActive((index + this.slides.length) % this.slides.length);
      this.track.scrollTo({ left:this.index * this.track.clientWidth, behavior:this.motion.matches ? 'instant' : 'smooth' });
      this.schedule();
    }
    setActive(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; });
      this.querySelector('[data-hero-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelectorAll('.hero-v3-segment').forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
      this.cards.forEach((card, i) => card.classList.toggle('is-current', i === 0));
      this.cardIndex = 0;
      this.schedule();
    }
    updatePause() {
      const button = this.querySelector('[data-hero-action="pause"]');
      button.hidden = this.motion.matches;
      button.setAttribute('aria-label', this.paused ? 'Start slideshow' : 'Pause slideshow');
      button.title = button.getAttribute('aria-label');
      button.dataset.paused = String(this.paused);
      button.textContent = this.paused ? '\u25b6' : '\u23f8';
    }
    schedule() {
      clearTimeout(this.timer);
      this.progressAnimation?.cancel();
      this.segmentAnimation?.cancel();
      this.dataset.playing = 'false';
      if (this.paused || this.motion.matches || this.focused || document.hidden || window.Shopify?.designMode) return;
      const duration = Number(this.dataset.interval) * 1000;
      this.dataset.playing = 'true';
      this.progressAnimation = this.querySelector('[data-hero-progress]').animate(
        [{ transform:'scaleX(0)' }, { transform:'scaleX(1)' }],
        { duration, easing:'linear', fill:'forwards' }
      );
      this.timer = setTimeout(() => this.show(this.index + 1), duration);
      this.segmentAnimation = this.querySelector('.hero-v3-segment[aria-current="true"] i').animate(
        [{ transform:'scaleX(0)' }, { transform:'scaleX(1)' }],
        { duration, easing:'linear', fill:'forwards' }
      );
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      clearInterval(this.cardTimer);
      clearTimeout(this.scrollTimer);
      this.resizeObserver?.disconnect();
      this.progressAnimation?.cancel();
      this.segmentAnimation?.cancel();
    }
  });
})();
